import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";

import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button,
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";

//redux
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

//Social Media Imports
// import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { loginUser, newPasswordRequired, setNewPassword } from "../../store/actions";

//Import config
// import { facebook, google } from "../../config";

import { createSelector } from "reselect";
import { toast } from "react-toastify";

const Login = (props) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  const toggleModal = () => {setModal(!modal)
    dispatch(newPasswordRequired(!isNewpasswordRequired))
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
    dispatch(loginUser(values, props.router.navigate));
    },
  });

  const newPasswordValidation = useFormik({
    enableReinitialize: true,
    initialValues: { newPassword: "", confirmPassword: "" },
    validationSchema: Yup.object({
      newPassword: Yup.string().required("Please enter a new password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Please confirm your new password"),
    }),
    onSubmit: (values) => {
      dispatch(setNewPassword(values.newPassword,props.router.navigate));
      toggleModal();
    },
  });

  const loginpage = createSelector(
    (state) => state.login,
    (state) => ({
      error: state.error,
      isNewpasswordRequired:state.isNewpasswordRequired
    })
  );
  // Inside your component
  const { error,isNewpasswordRequired } = useSelector(loginpage);

  useEffect(() => {
    document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };

  });

  useEffect(()=>{
    isNewpasswordRequired && setModal(!modal)
  },[isNewpasswordRequired])

  useEffect(() => {
    if (error?.response?.data ) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [error]);
  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      <Link to="/">
                        <img
                          src={logodark}
                          alt=""
                          height="24"
                          className="auth-logo logo-dark mx-auto"
                        />
                        <img
                          src={logolight}
                          alt=""
                          height="24"
                          className="auth-logo logo-light mx-auto"
                        />
                      </Link>
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 text-center">
                      Welcome Back!
                    </h4>
                    <p className="mb-5 text-center">
                      Sign in to continue to Control Room.
                    </p>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                     
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <Label className="form-label">Email</Label>
                            <Input
                              name="email"
                              className="form-control"
                              placeholder="Enter email"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">
                                <div>{validation.errors.email}</div>
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-4">
                            <Label className="form-label">Password</Label>
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type="password"
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                <div> {validation.errors.password} </div>
                              </FormFeedback>
                            ) : null}
                          </div>

                          <Row>
                            {/* <Col>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customControlInline"
                                />
                                <label
                                  className="form-label form-check-label"
                                  htmlFor="customControlInline"
                                >
                                  Remember me
                                </label>
                              </div>
                            </Col> */}
                            <Col >
                              <div className="text-md-end mt-3 mt-md-0">
                                <Link
                                  to="/forgot-password"
                                  className="text-muted"
                                >
                                  <i className="mdi mdi-lock"></i> Forgot Password?
                                </Link>
                              </div>
                            </Col>
                          </Row>
                          <div className="d-grid mt-4">
                            <button
                              className="btn btn-primary waves-effect waves-light"
                              type="submit"
                            >
                              Log In
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* New Password Modal */}
      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Set a New Password</ModalHeader>
        <ModalBody>
          <Form onSubmit={(e) => { e.preventDefault(); newPasswordValidation.handleSubmit(); }}>
            <div className="mb-3">
              <Label>New Password</Label>
              <Input
                type="password"
                name="newPassword"
                onChange={newPasswordValidation.handleChange}
                onBlur={newPasswordValidation.handleBlur}
                value={newPasswordValidation.values.newPassword}
                invalid={!!newPasswordValidation.errors.newPassword}
              />
              <FormFeedback>{newPasswordValidation.errors.newPassword}</FormFeedback>
            </div>
            <div className="mb-3">
              <Label>Confirm Password</Label>
              <Input
                type="password"
                name="confirmPassword"
                onChange={newPasswordValidation.handleChange}
                onBlur={newPasswordValidation.handleBlur}
                value={newPasswordValidation.values.confirmPassword}
                invalid={!!newPasswordValidation.errors.confirmPassword}
              />
              <FormFeedback>{newPasswordValidation.errors.confirmPassword}</FormFeedback>
            </div>
            <ModalFooter>
              <Button type="submit" color="primary">Update Password</Button>
              <Button color="secondary" onClick={toggleModal}>Cancel</Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
